import styled from 'styled-components'
import ItemRowCard from './ItemRowCard'

const ItemRowValueCard = styled(ItemRowCard)`
  color: ${props => (props.color ? props.color : '#4d4e4f')};
  font-size: 14px;
  line-height: 16px;
`
export default ItemRowValueCard
